import { render } from "./TabsControlByRoute.vue?vue&type=template&id=064faaea&scoped=true"
import script from "./TabsControlByRoute.vue?vue&type=script&lang=js"
export * from "./TabsControlByRoute.vue?vue&type=script&lang=js"

import "./TabsControlByRoute.vue?vue&type=style&index=0&id=064faaea&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-064faaea"]])

export default __exports__